import { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import Reveal from "@/components/Reveal";
import { api } from "@/lib/api";

const Stars = ({ n }) => (
  <div className="flex gap-1" aria-label={`Valutazione ${n} su 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`h-4 w-4 ${i <= n ? "fill-[#2997AB] text-[#2997AB]" : "text-[#C9DBDF]"}`} />
    ))}
  </div>
);

export default function TestimonialsSection() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (items === null) return null;

  return (
    <section className="mx-auto max-w-7xl px-5 py-24 sm:px-8" data-testid="testimonials-section">
      <Reveal>
        <p className="font-plex text-xs uppercase tracking-[0.28em] text-[#1F8296]">Cosa dicono di noi</p>
        <h2 className="text-balance mt-4 max-w-2xl font-display text-3xl font-semibold tracking-tight text-[#1A2E33] sm:text-4xl">
          Le parole dei nostri partecipanti
        </h2>
      </Reveal>

      {items.length === 0 ? (
        <Reveal delay={0.1}>
          <div className="mt-12 rounded-3xl border border-[#D8E5E8] bg-[#EFF6F7] p-10 text-center" data-testid="testimonials-empty">
            <Quote className="mx-auto h-8 w-8 text-[#1F8296]" />
            <p className="mt-4 font-display text-xl font-semibold text-[#1A2E33]">
              Le prime recensioni stanno arrivando
            </p>
            <p className="mx-auto mt-2 max-w-md text-sm text-[#5C7178]">
              Stiamo raccogliendo i commenti di chi ha frequentato i nostri corsi: torna presto a trovarci.
            </p>
          </div>
        </Reveal>
      ) : (
        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={0.07 * i}>
              <figure className="flex h-full flex-col rounded-3xl border border-[#D8E5E8] bg-white p-7 shadow-[0_10px_40px_-28px_rgba(16,51,59,0.3)] transition-colors duration-500 hover:border-[#1F8296]/50">
                <Quote className="h-6 w-6 text-[#2997AB]" />
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-[#42565D]">
                  "{t.testo}"
                </blockquote>
                <figcaption className="mt-6 flex items-center justify-between gap-3 border-t border-[#E3EDEF] pt-4">
                  <div>
                    <p className="font-display text-base font-semibold text-[#1A2E33]">{t.nome}</p>
                    {t.corso && <p className="text-xs text-[#7A8F96]">{t.corso}</p>}
                  </div>
                  <Stars n={t.rating || 5} />
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      )}
    </section>
  );
}
